import { gql } from "@apollo/client";
import { EVENT_SUBCONTRACTOR_FIELDS } from "graphql/query/event-subcontractor-gql";

export const CREATE_EVENT_SUBCONTRACTOR = gql`
    mutation CreateEventSubcontractor($input: ExhibitionEventSubcontractorFieldsInput!) {
        eeSubcontractorCreate(input: $input) {
            label
            message
            exhibitionEventSubcontractor { ...EventSubcontractorFields }
        }
    }
    ${ EVENT_SUBCONTRACTOR_FIELDS }
`;

export const UPDATE_EVENT_SUBCONTRACTOR = gql`
    mutation UpdateEventSubcontractor($input: ExhibitionEventSubcontractorFieldsInput!) {
        eeSubcontractorUpdate(input: $input) {
            label
            message
            exhibitionEventSubcontractor { ...EventSubcontractorFields }
        }
    }
    ${ EVENT_SUBCONTRACTOR_FIELDS }
`;

export const DELETE_EVENT_SUBCONTRACTOR = gql`
    mutation DeleteEventSubcontractor($id: ID!) {
        eeSubcontractorDelete(id: $id) { label message }
    }
`;
